import React from 'react';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import PageLink from 'components/PageLink/PageLink';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  IsCreatePaymentPlan?:boolean;
}

const PaymentErrorPanel = ({ PageData, Model, IsCreatePaymentPlan }: Props) => {
  const ERROR_ICONS_PATH = `${process.env.PUBLIC_URL}/images/icons/`;
  const exclamationmarkIcon = `${ERROR_ICONS_PATH}/exclamationmark.svg`;
  const retryIcon = `${ERROR_ICONS_PATH}/retry.svg`;

  const retryMakePaymentTracking = () =>{
    if(IsCreatePaymentPlan){
      var tagManagerArgs = {
        dataLayer: { 
          event : 'retry_payment',
           checkout_name : 'Payment Plan Creation'
          }
        };    
      TagManager.dataLayer(tagManagerArgs);
    }
    else{
      var tagManagerArgs = {
        dataLayer: { 
          event : 'retry_payment',
              checkout_name: Model?.IsUserAuthenticated ? (Model?.IsFromOffer ? 'Settle Account' : 'Single Payment - Logged In') : 'Single Payment - Logged Out'
          }
        };    
      TagManager.dataLayer(tagManagerArgs);
    }
   
  }

  const retryMakePaymentClick = ()=>{
      
      retryMakePaymentTracking();
      if(Model?.MakePaymentUrl)
      {      
      window.location = Model?.MakePaymentUrl;
      }
      if(Model?.RetryPaymentPageUrl)
      {
        window.location = Model?.RetryPaymentPageUrl;
      }

  }

  return (
    <div className="Page-container PageContainer--transparent u-paddingTsm u-paddingBsm">
      <div className="paymentSuccessful u-marginTz">
        <div className="Grid Grid--white GridWhite--smFull">
          <div className="Grid-cell u-size1of1 ">
            <div className="Statepage">
              <div className="Statepage-icon">
                <img className="u-marginTsm" src={exclamationmarkIcon} />
              </div>
              {(Model?.PaymentError || Model?.IsAdyenPaymentError) && (
                <div>
                  <h2 className="Heading Statepage-heading">
                    {PageData?.PaymentErrorHeader}
                  </h2>
                  <div className="Statepage-text">
                    {PageData?.PaymentErrorInfo}
                  </div>
                </div>
              )}
              {(Model?.TokenExpired || Model?.IsPaymentTokenExpired) && (
                <div>
                  <h2 className="Heading Statepage-heading">
                    {PageData?.PaymentTokenExpiredHeader}
                  </h2>
                  <div className="Statepage-text">
                    {PageData?.PaymentTokenExpiredInfo}
                  </div>
                </div>
              )}
              {!isNullOrWhiteSpace(Model.RetryPaymentPageUrl) && (
                <div>
                  <div className="Statepage-text">
                    {PageData?.RetryPaymentTextInfo}
                  </div>
                  <button className="Button" type="button" onClick={retryMakePaymentClick}>
                    <span>
                      {PageData?.RetryPaymentButtonLabel}
                      <img className="Icon" src={retryIcon} />
                    </span>
                  </button>
                </div>
              )}
              {Model.MakePaymentUrl != null && (
                <button className="Button" type="button" onClick={retryMakePaymentClick}>
                  <span>
                    {PageData?.PaymentErrorButtonLabel}
                    <img className="Icon" src={retryIcon} />
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PaymentErrorPanel;
